import { useEffect } from 'react';

import { usePrevious } from '../../core/hooks/usePrevious.js';
import { useBreakpoint } from '../hooks/useBreakpoint.js';

/** @internal */
export function useWatchBreakpoint({
  breakpoint,
  callback,
}: {
  breakpoint: number;
  callback: (
    value: boolean,
    reason: 'above breakpoint' | 'below breakpoint',
  ) => void;
}) {
  const matchesBreakpoint = useBreakpoint(`(min-width: ${breakpoint}px)`, true);
  const prev = usePrevious(matchesBreakpoint);

  useEffect(
    function callCallback() {
      // skip closing panel on first render if above breakpoint
      if (prev === undefined && matchesBreakpoint) {
        return;
      }
      if (matchesBreakpoint === prev) {
        return;
      }

      if (matchesBreakpoint) {
        callback(false, 'above breakpoint');
        return;
      }

      callback(true, 'below breakpoint');
    },
    [matchesBreakpoint, prev, callback],
  );

  return matchesBreakpoint;
}
